import React from "react"
import PropTypes from "prop-types"
import { Box } from "@chakra-ui/react"

const Price = ({ price, salePrice, onSale, saleActive }) => {
  return (
    <Box id="priceBox" width="100%" fontSize={'20px'} paddingTop={2} paddingBottom={2}>
      {saleActive && onSale && salePrice && salePrice > 0 && price > salePrice ?
        <Box lineHeight={'normal'}>
          <Box textDecoration={'line-through'} id="price" >£ {price}</Box>
          <Box fontWeight={'bold'} id="salePrice" >£ {salePrice}</Box>
        </Box>
        :
        <Box id="price">
          £ {price}
        </Box>
      }
    </Box>
  )
}

export default Price

Price.propTypes = {
  price: PropTypes.number.isRequired,
  salePrice: PropTypes.number,
  onSale: PropTypes.bool,
  saleActive: PropTypes.bool
}

Price.defaultProps = {
  salePrice: 0,
  onSale: false,
  saleActive: false
}

